import { render, staticRenderFns } from "./TermsReview.vue?vue&type=template&id=6d8587ac&scoped=true"
import script from "./TermsReview.vue?vue&type=script&lang=js"
export * from "./TermsReview.vue?vue&type=script&lang=js"
import style0 from "./TermsReview.vue?vue&type=style&index=0&id=6d8587ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8587ac",
  null
  
)

export default component.exports